import script from "./SortingListDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortingListDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SortingListDropdown.vue?vue&type=style&index=0&id=ccf75f06&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf75f06"]])

export default __exports__